import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 5 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
export default class clients extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                 <Carousel
                  partialVisbile={false}
                  arrows={false}
                  swipeable={false}
                  draggable={false}
                  showDots={true}
                  responsive={responsive}
                  ssr={false} // means to render carousel on server-side.
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={2000}
                  keyBoardControl={true}
                  customTransition="all 800ms linear"
                  transitionDuration={900}
                  containerClass="carousel-container"
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px "
              >
                <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/H7tNDdJ/partners4.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/H7CtppL/partner1.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        {/* <div className="d-flex justify-content-center">
                        <div className="clients ">
                        <img
                          src="https://i.ibb.co/vXVqpXW/image.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div> */}
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/CPpT5z2/partners5.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/SV1wqbw/partner6.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/7WbZKQB/partner2.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/cYvZ74m/partners8.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/yhPvrLD/partners7.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/WkxTKrW/partners9.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                        <div className="d-flex justify-content-center">
                        <div className="partners ">
                        <img
                          src="https://i.ibb.co/yX1xzKh/partner3.png"
                          alt="Third slide"
                          className="img-fluid"
                        />
                        </div>
                        </div>
                            </Carousel>
            </>
        )
    }
}

